module.exports = __webpack_public_path__ + "img/offline-big.14b867d0.svg";